/** Match backend ADMIN_PASSWORD_LENGTH / charset (tenanthub-superadmin-backend/src/utils/password.js). */
export const ADMIN_PASSWORD_LENGTH = 64;

const UPPER = 'ABCDEFGHJKLMNPQRSTUVWXYZ';
const LOWER = 'abcdefghijkmnopqrstuvwxyz';
const DIGITS = '23456789';
const SYMBOLS = '!@#$%^&*-_=+?';
const ALL = UPPER + LOWER + DIGITS + SYMBOLS;

const randomInt = (max) => {
  const buf = new Uint32Array(1);
  crypto.getRandomValues(buf);
  return buf[0] % max;
};

const shuffle = (chars) => {
  const arr = [...chars];
  for (let i = arr.length - 1; i > 0; i -= 1) {
    const j = randomInt(i + 1);
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
};

/** Cryptographically strong admin password (default 64 chars). */
export const generateStrongPassword = (length = ADMIN_PASSWORD_LENGTH) => {
  const size = Math.max(16, Number(length) || ADMIN_PASSWORD_LENGTH);
  const required = [
    UPPER[randomInt(UPPER.length)],
    LOWER[randomInt(LOWER.length)],
    DIGITS[randomInt(DIGITS.length)],
    SYMBOLS[randomInt(SYMBOLS.length)]
  ];
  const rest = [];
  for (let i = required.length; i < size; i += 1) {
    rest.push(ALL[randomInt(ALL.length)]);
  }
  return shuffle([...required, ...rest]).join('');
};
